<script lang="ts">
	interface Props {
		class?: string;
		pictureFallbackBackground?: boolean;
		children?: import("svelte").Snippet;
		background?: import("svelte").Snippet;
	}

	let {
		class: classes = "",
		pictureFallbackBackground = false,
		children,
		background,
	}: Props = $props();
</script>

<div
	class="cover relative isolate laptop:mx-edge-x my-6 {classes} {pictureFallbackBackground
		? `picture-fallback-background`
		: ``}"
>
	<div class="px-edge-x laptop:px-cover-x relative text-shadow-[0_0_1.5rem_rgba(0,0,0,.75)]">
		{@render children?.()}
	</div>

	<div class="background absolute inset-0 z--1">
		{@render background?.()}
	</div>
</div>

<style lang="postcss">
	:where(:global(.cover)) {
		margin-block-start: var(--mt, initial);
		margin-block-end: var(--mb, initial);
	}

	.background > :global(*) {
		display: contents;
	}

	.picture-fallback-background::after {
		background: center / cover no-repeat var(--cover-img-lqip, var(--img-fallback, transparent));
		content: "";
		display: block;
		inset: 1px 0; /* 1px smaller to avoid color bleed */
		position: absolute;
		z-index: -2;
	}

	@media (--laptop) {
		.picture-fallback-background::after {
			border-radius: 1rem;
			inset: 1px; /* 1px smaller to avoid color bleed */
		}
	}
</style>
